import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** requests payments operators list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentsoperators
*/
export const getPaymentsOperators = payload => {
	return httpClient({
		method: 'GET',
		url: 'payments/operators'
	})
}

/** Get Payments List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentssearch
*/
export const getPaymentsList = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'payments/search',
        params: payload,
		isCancellable: true
	})
}

/** Sends a Payment operation notification to email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_payments%7Bid%7Dreceiptemail
*/
export const sendPaymentEmailNotification = payload => {
	return httpClient({
		method: 'GET',
		url: `payments/${payload.id}/receipt/email`,
		params: payload.data
	})
}

/** Sends a Payment operation notification to sms
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_payments%7Bid%7Dreceiptsms
*/
export const sendPaymentSMSNotification = payload => {
	return httpClient({
		method: 'GET',
		url: `payments/${payload.id}/notification/sms`,
		params: payload.data
	})
}

/** Creates the url to download payment operation receipt/exctrat pdf
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_payments%7Bid%7Dreceipt
*/
export const createDownloadPaymentReceiptPdf = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `payments/${payload}/receipt`
	})
}

/** Get Payment Detail
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_payments%7Bid%7D
*/
export const getPaymentDetail = (payload) => {
	return httpClient({
		method: 'GET',
		url: `payments/${payload.paymentId}`,
		isCancellable: true
	})
}

/** requests payments status list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentsstatus
*/
export const getPaymentsStatus = () => {
	return httpClient({
		method: 'GET',
		url: 'payments/status'
	})
}
